// extracted by mini-css-extract-plugin
module.exports = {"button":"ScrollToTopButton_button__ifyqd"};